export default __webpack_public_path__ + "static/media/mail.9eb6cbd4.svg";